/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_GroupInputs */



/**
* | output |
* | --- |
* | "Target Group" |
*
* @param {Target_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_group = /** @type {((inputs?: Target_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo target")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая группа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo objetivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标群体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象グループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्षित समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Público-alvo")
	return /** @type {LocalizedString} */ ("Target Group")
});